import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import {
    showInitiativeLoader,
    onSaveInitiative,
    onInitiativeClose,
} from 'actions/initiative';
import moment from 'moment';
import { isDateBefore } from 'services/DateService';
import { isValueEntered } from 'services/Validation';
import { inputFields, displayedImage, showErrors, modalHeader, isFormValid, getFormError, checkDatesValid } from '../common';

const InitiativeAdd = () => {
    const dispatch = useDispatch();
    const addInitiativeState = useSelector(state => state.initiatives.addInitiativeState);
    const allProjects = useSelector(state => state.projects.allProject);
    const [selectedInitiative, setSelectedInitiative] = useState(initProps);
    const [formErrors, setFormErrors] = useState({ name: '' });
    const [formValid, setFormValid] = useState(false);

    useEffect(() => {
        setSelectedInitiative(initProps());
    }, [addInitiativeState]);

    // using selectedInitiative makes it behave like componentDidUpdate - effect takes place when selectedInitiative changes
    useEffect(() => {
        setFormValid(false);
        validateForm();
    }, [selectedInitiative]);

    const initProps = () => {
        return {
            id: '',
            orgid: '',
            name: '',
            description: '',
            status: '',
            projectId: '',
            products: [],
            startDate: '',
            endDate: '',
            budget: 0,
            starred: false,
            frequently: false,
        };
    };

    const handleUserInput = (event, isNumber) => {
        const name = event.target.name;
        let value = event.target.value;
        if (isNumber) {
            value = Number(event.target.value);
        }
        updateSelectedInitiativeField(name, value);
        validateField(name, value);
    };

    const handleDateInput = (name, value) => {
        updateSelectedInitiativeField(name, value);
        validateDateFields(name, value);
        validateForm();
    };

    const updateSelectedInitiativeField = (fieldName, value) => {
        const newInitiative = { ...selectedInitiative };
        newInitiative[fieldName] = value;
        setSelectedInitiative(newInitiative);
    };

    const validateDateFields = (name, value) => {
        formErrors['dates'] = '';
        switch (name) {
            case 'endDate':
                // check its not before the start date
                if (isValueEntered(value) && isValueEntered(selectedInitiative?.startDate)) {
                    if (isDateBefore(moment(value), moment(selectedInitiative?.startDate))) {
                        formErrors['dates'] = ' are invalid. The end date selected cannot be before the start date';
                    }
                }
                break;
            case 'startDate':
                // check its not after the end date
                if (isValueEntered(selectedInitiative?.endDate) && isValueEntered(value)) {
                    if (isDateBefore(moment(selectedInitiative?.endDate), moment(value))) {
                        formErrors['dates'] = ' are invalid. The start date selected cannot be after the end date';
                    }
                }
                break;
            default:
                break;
        }
    };

    const validateField = (fieldName, value) => {
        formErrors[fieldName] = getFormError(fieldName, value);
        setFormErrors(formErrors);
        validateForm();
    };

    const validateForm = () => {
        setFormValid(isFormValid(selectedInitiative) && checkDatesValid(selectedInitiative));
    };

    const maintainButton = (label) => {
        return (
            <Button className="text-uppercase" disabled={!formValid} color="primary" onClick={() => {
                dispatch(showInitiativeLoader());
                dispatch(onInitiativeClose());
                dispatch(onSaveInitiative(selectedInitiative));
                setSelectedInitiative(initProps());
                setFormValid(false);
            }}>
                {label}
            </Button>
        );
    };

    const modalHeaderOnClick = () => {
        return () => {
            setFormValid(false);
            dispatch(onInitiativeClose());
        };
    };

    const modalBody = (buttonText) => {
        return (
            <Fragment>
                <div className="modal-box-content">
                    <div className="row no-gutters">
                        {displayedImage(selectedInitiative)}
                        {showErrors(formErrors)}
                        {inputFields(selectedInitiative, allProjects, handleUserInput, handleDateInput)}
                    </div>
                </div>

                <div className="modal-box-footer d-flex flex-row">
                    {maintainButton(buttonText)}
                </div>
            </Fragment>
        );
    };
    
    return (
        <Modal className="modal-box" isOpen={addInitiativeState}>
            {modalHeader(<IntlMessages id="initiative.addInitiative" />, modalHeaderOnClick)}
            {modalBody(<IntlMessages id="initiative.addInitiative" />)}
        </Modal>
    );
};

export default InitiativeAdd;


// WEBPACK FOOTER //
// ./components/Agile/initiative/initiativeMaintenance/initiativeAdd/index.js